import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Нажмите, чтобы обновить QR-код ")

import { useLocalStorage } from "@vueuse/core";

import UiCard from "@/plugins/ui/components/card/UiCard.vue";
import UiHeader from "@/plugins/ui/components/header/UiHeader.vue";

import UiIcon from "./ui/UiIcon.vue";
import UiCollapse from "./ui/UiCollapse.vue";
import UiGroup from "@/plugins/ui/components/group/UiGroup.vue";
import UiQrcode from "./ui/UiQrcode.vue";
import { useQr } from "@/use/useQr";
import axios from "axios";
import { onMounted, onUnmounted, ref } from "vue";
import UiCaption from "@/plugins/ui/components/typography/UiCaption.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'QrAccess',
  setup(__props) {

const show = useLocalStorage("expand-qr-code", true);

const timer = ref();
const { counterIndex, cancelIndex, fetchQr, qr } = useQr();

async function poll() {
  try {
    await counterIndex();
    await loadQr();
    await poll();
  } catch (error) {
    if (
      axios.isAxiosError(error) &&
      error.response &&
      error.response.status === 504
    ) {
      await poll();
    } else {
      await new Promise((resolve) => setTimeout(resolve, 5000));
      await poll();
    }
  }
}
async function loadQr() {
  await fetchQr();
  refresh();
}

function refresh() {
  clearInterval(timer.value);
  timer.value = setInterval(() => loadQr(), 10 * 1000);
}

onMounted(() => {
  loadQr();
  poll();
});

onUnmounted(() => {
  clearInterval(timer.value);
  cancelIndex();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UiGroup, null, {
    default: _withCtx(() => [
      _createVNode(UiCollapse, {
        modelValue: _unref(show),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(show) ? (show).value = $event : null))
      }, {
        header: _withCtx(() => [
          _createVNode(UiHeader, {
            title: "QR-код доступа",
            description: "Ваш персональный код доступа"
          }, {
            right: _withCtx(() => [
              _createVNode(UiIcon, {
                icon: "ChevronDown",
                size: 18,
                class: _normalizeClass(["transition duration-200", {
                'transform-gpu rotate-180': _unref(show),
              }])
              }, null, 8, ["class"])
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(UiCard, null, {
            default: _withCtx(() => [
              _createVNode(UiQrcode, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (loadQr())),
                width: 280,
                value: _unref(qr),
                class: "mx-auto"
              }, null, 8, ["value"]),
              _createVNode(UiCaption, { style: {"text-align":"center","margin-top":"8px"} }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})